import { createFileRoute, redirect } from '@tanstack/react-router';

// [2026-06-08] /settings/strategy is gone — the target-market form
// moved to the /home onboarding checklist (autodetect + confirm step)
// and the heartbeats panel moved to /home left lane as
// SidebarNextStepsCard. Nothing left for this route to do; redirect
// to home so the founder doesn't see an empty pane.
export const Route = createFileRoute('/brand/$slug/settings/strategy')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/brand/$slug/home', params: { slug: params.slug } });
  },
});
